// baner ze sliderem z CategoryTree po lewej stronie
// @ts-nocheck

import React from "react";
import { CarouselProvider, Slide, Slider, ButtonBack, ButtonNext } from "pure-react-carousel";
import { ArrowLeft, ArrowRight } from "react-bootstrap-icons";
import qs from "query-string";
import classnames from "classnames";
import { Grid } from "@mui/material";

import { useGetHomeSlider } from "api";
import { useRWD } from "hooks";
import { Link } from "components/controls";
import CategoryTree from "components/layouts/MainLayout/components/HeaderBottomBar/components/CategoryTree/CategoryTree";
import HomeBlocks from "pages/Home/components/HomeBlocks/HomeBlocks.extend";

import styles from "theme/pages/Home/components/Banner/Banner.module.scss";

export const Banner = () => {
  const { data: homeSliderData } = useGetHomeSlider();
  const { isMobile } = useRWD();

  // Filtrowanie slajdów na podstawie urządzenia i pola layouts
  const filteredSlides = React.useMemo(() => {
    if (!homeSliderData?.items) return [];
    return homeSliderData.items.filter((slideData: any) => {
      const layout = slideData.layouts;
      return isMobile ? layout === "Mobile" : layout === "Desktop";
    });
  }, [homeSliderData?.items, isMobile]);

  return (
    <div
      className={classnames(
        styles.componentWrapper,
        "StylePath-Pages-Home-components-Banner"
      )}
    >
      <Grid container className={styles.gridContainer}>
        <Grid item className={styles.categoryTreeColumn}>
          <CategoryTree />
        </Grid>
        <Grid item className={styles.sliderColumn}>
          {filteredSlides.length > 0 && (
            <div className={styles.slider}>
              <CarouselProvider
                naturalSlideWidth={0}
                naturalSlideHeight={0}
                totalSlides={filteredSlides.length}
                visibleSlides={1}
                isPlaying
              >
                <div className={styles.sliderWrapper}>
                  <ButtonBack className={styles.navButtonBack}>
                    <ArrowLeft />
                  </ButtonBack>
                  
                  <Slider>
                    {filteredSlides.map((slideData, index) => (
                      <Slide
                        key={slideData.id}
                        index={index}
                        className={styles.slide}
                        style={{ backgroundImage: `url('${slideData.image}')` }}
                      >
                        {slideData.url ? (
                          <a
                            href={slideData.url}
                            target={slideData.new_tab ? "_blank" : "_self"}
                            className={styles.slideLink}
                            rel="noreferrer"
                          />
                        ) : (
                          <Link
                            to={`/products?${qs.stringify(
                              {
                                category_id: slideData.category_id,
                                search_keyword: slideData.search_keyword,
                                sort_method: slideData.sort_method,
                              },
                              { skipNull: true }
                            )}`}
                            target={slideData.new_tab ? "_blank" : "_self"}
                            className={styles.slideLink}
                          />
                        )}
                      </Slide>
                    ))}
                  </Slider>
                  
                  <ButtonNext className={styles.navButtonNext}>
                    <ArrowRight />
                  </ButtonNext>
                </div>
              </CarouselProvider>
            </div>
          )}
          <HomeBlocks />
        </Grid>
      </Grid>
    </div>
  );
};

export default Banner;

